import own from "./Stars.module.css";

/** Three star slots, filled and pale — a child sees from the start there are three. */
export function Stars({ count }: { count: number }) {
  return (
    <span aria-label={`${count} von 3 Sternen`}>
      <span className={own.starsFilled}>{"★".repeat(count)}</span>
      <span className={own.starsEmpty}>{"★".repeat(3 - count)}</span>
    </span>
  );
}
